import axios from 'axios';
import { getAuth } from 'firebase/auth';

const BASE_URL = import.meta.env.VITE_API_BASE_URL

if (!BASE_URL) {
  console.error('❌ VITE_API_BASE_URL is not defined and no fallback is available.');
}

console.log('✅ Using API base URL:', BASE_URL);

// Create Axios instance
const axiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Request interceptor: Attach fresh Firebase ID token
axiosInstance.interceptors.request.use(
  async (config) => {
    try {
      const auth = getAuth();
      const user = auth.currentUser;

      if (user) {
        const token = await user.getIdToken(true); // forceRefresh = true
        config.headers['Authorization'] = `Bearer ${token}`;
      }
    } catch (error) {
      console.warn('⚠️ Could not attach Firebase token:', error.message);
    }

    return config;
  },
  (error) => {
    console.error('❌ Request error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor: Handle auth and network errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const originalRequest = error.config;

    if (error.response) {
      const status = error.response.status;

      if (status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;

        // Remove token and store the attempted path for post-login redirect
        localStorage.removeItem('access_token');
        localStorage.setItem('redirect_after_login', window.location.pathname);

        window.location.href = '/signin';
      } else {
        console.error(
          '❌ API error:',
          error.response.data?.message || error.response.statusText
        );
      }
    } else if (error.request) {
      console.error('❌ Network error: No response from server.');
    } else {
      console.error('❌ Axios setup error:', error.message);
    }

    return Promise.reject(error);
  }
);

export const getApiBaseUrl = () => BASE_URL;

export default axiosInstance;
